import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=294569ce&scoped=true&"
import script from "./edit-profile.vue?vue&type=script&lang=js&"
export * from "./edit-profile.vue?vue&type=script&lang=js&"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=294569ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294569ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VTab,VTabItem,VTabs,VTabsItems})
